import script from "./VoiceContent.vue?vue&type=script&setup=true&lang=js"
export * from "./VoiceContent.vue?vue&type=script&setup=true&lang=js"

import "./VoiceContent.vue?vue&type=style&index=0&id=48a4cff4&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48a4cff4"]])

export default __exports__